import "../../styles/hos/components/boot.css";

type Props = {
  /** Screen-reader text; the loader itself shows no words. */
  label: string;
};

/**
 * Full-screen loading state while a route or module chunk loads. It covers the legacy page background so
 * the old design never flashes between screens; the spinner appears only after a short delay, so fast loads
 * show nothing but the calm HOS background.
 */
export function HosBootLoader({ label }: Props) {
  return (
    <div className="hos-ui hos-boot" role="status" aria-live="polite">
      <span className="hos-boot__spinner" aria-hidden="true" />
      <span className="hos-boot__label">{label}</span>
    </div>
  );
}
